(function () {
  const popularProductsSlider = () => {
    const sliders = Array.from(
      document.querySelectorAll(".popular-products__swiper-container")
    );
    if (sliders.length === 0) return;

    sliders.forEach((slider) => {
      const swiperEl = slider.querySelector(".swiper");
      if (!swiperEl || swiperEl.swiper) return;

      const sectionId = slider.dataset.id;
      const autoplay = toBoolean(slider.dataset.autoplay);
      const enableNavigation = toBoolean(slider.dataset.navigation);
      const enableLoop = toBoolean(slider.dataset.loop);
      const productsToShow = parseInt(slider.dataset.products, 10) || 4;
      const gapRaw = parseInt(slider.dataset.gap, 10);
const gap = Number.isFinite(gapRaw) && gapRaw > 0 ? gapRaw : 0;

      let autoplayParam = {};
      if (autoplay) {
        autoplayParam = {
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
        };
      }

      let navigationParam = {};
      if (enableNavigation) {
        navigationParam = {
          navigation: {
            nextEl: `#${sectionId} .popular-products__btn-next`,
            prevEl: `#${sectionId} .popular-products__btn-prev`,
          },
        };
      }

      // Desktop = setting wali value, tablet/mobile me usse zyada na ho
      const tablet = Math.min(3, productsToShow);
      const small = Math.min(2, productsToShow);

      const gapMobile = Math.min(gap, 12);
const gapSmall = Math.min(gap, 16);
const gapTablet = Math.min(gap, 20);

      new Swiper(swiperEl, {
        loop: enableLoop,
        longSwipesRatio: 0.1,
        slidesPerView: 1,
        spaceBetween: gapMobile,
        ...autoplayParam,
        ...navigationParam,
        breakpoints: {
          750: {
            slidesPerView: small,
            spaceBetween: gapSmall,
          },
          990: {
            slidesPerView: tablet,
            spaceBetween: gapTablet,
          },
          1200: {
            slidesPerView: productsToShow,
            spaceBetween: gap,
          },
        },
      });
    });
  };

  function toBoolean(string) {
    return string === "true";
  }

  document.addEventListener("DOMContentLoaded", function () {
    popularProductsSlider();
    document.addEventListener("shopify:section:load", function () {
      popularProductsSlider();
    });
  });
})();